import Navbar from "../NavBar/NavBar";
import "./About.css";

const TEAM = [
  {
    name: "حكمت حاج عمر",
    role: "مدير الفريق",
    tag: "Team Lead",
    initials: "حع",
  },
  {
    name: "أحمد الزراعي",
    role: "مطوّر React",
    tag: "Frontend Developer",
    initials: "أز",
  },
  {
    name: "جميل فارس",
    role: "مطوّر Flutter",
    tag: "Mobile Developer",
    initials: "جف",
  },
  {
    name: "أحمد عبد الرحمن",
    role: "مطوّر Back-End",
    tag: "Backend Developer",
    initials: "أع",
  },
];

export default function AboutPage() {
  return (
    <>
      <Navbar />

      <div className="team-page">
        <section className="team-hero">
          <div className="team-hero-inner">
            <span className="team-hero-badge">LP-ROM</span>
            <h1 className="team-hero-title">فريقنا البرمجي</h1>
            <p className="team-hero-sub">
              مجموعة من المطوّرين الشغوفين نعمل معاً على بناء منصّة تعليمية
              حديثة وموثوقة، كل واحد فينا بيتقن اختصاصه ليطلع لكم منتج بجودة
              عالية.
            </p>
            <div className="team-hero-divider" />
          </div>
        </section>

        <section className="team-grid-section">
          <div className="team-grid">
            {TEAM.map((m) => (
              <div className="team-card" key={m.name}>
                <div className="team-card-avatar">
                  <span>{m.initials}</span>
                </div>
                <h3 className="team-card-name">{m.name}</h3>
                <p className="team-card-role">{m.role}</p>
                <span className="team-card-tag">{m.tag}</span>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}
